import React from 'react'
import Navbar from '../../Components/Home/Navbar/Navbar'
import Contact from '../../Components/Contact/Contact'
import Footer from '../../Components/Home/Footer/Footer'

const ContactUs = () => {
  return (
    <div>
      <Navbar />
      <Contact />
      <Footer />
    </div>
  )
}

export default ContactUs
